import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { STAR_RATING_MINUTES, STAR_RATING_LABELS } from '../../../core/services/feedback.service';

@Component({
  selector: 'app-agent-feedback-modal',
  templateUrl: './agent-feedback-modal.component.html',
  styleUrls: ['./agent-feedback-modal.component.scss'],
  standalone: false
})
export class AgentFeedbackModalComponent implements OnInit {
  
  @Input() agentName: string = '';

  get messageKey(): string {
    const messageKeys: Record<string, string> = {
      'UNITTEST': 'FEEDBACK.MESSAGE_UNITTEST',
      'REFACTOR': 'FEEDBACK.MESSAGE_REFACTOR'
    };
    return messageKeys[this.agentName] || 'FEEDBACK.MESSAGE';
  }
  
  selectedStars: number = 0;
  hoveredStars: number = 0;
  stars: number[] = [1, 2, 3, 4, 5];
  comment: string = '';
  
  constructor(private modalController: ModalController) { }

  ngOnInit(): void {
  }

  /**
   * Maneja el hover sobre una estrella
   */
  onStarHover(star: number): void {
    this.hoveredStars = star;
  }

  /**
   * Maneja cuando el ratón sale de las estrellas
   */
  onStarsLeave(): void {
    this.hoveredStars = 0;
  }

  /**
   * Maneja el click en una estrella
   */
  onStarClick(star: number): void {
    this.selectedStars = star;
  }

  /**
   * Comprueba si una estrella debe estar rellena
   */
  isStarFilled(star: number): boolean {
    if (this.hoveredStars > 0) {
      return star <= this.hoveredStars;
    }
    return star <= this.selectedStars;
  }

  /**
   * Obtiene la etiqueta de tiempo ahorrado para la selección actual
   */
  getTimeSavedLabel(): string {
    const starCount = this.hoveredStars > 0 ? this.hoveredStars : this.selectedStars;
    if (starCount === 0) return '';
    
    return STAR_RATING_LABELS[starCount] || '';
  }

  /**
   * Envía el feedback
   */
  onSubmit(): void {
    if (this.selectedStars > 0) {
      this.modalController.dismiss({
        result: 'submitted',
        stars: this.selectedStars,
        minutesSaved: STAR_RATING_MINUTES[this.selectedStars] || 0,
        comment: this.comment.trim() || undefined
      });
    }
  }
}
